export const userStatusList = [
    { label: "Active", value: true },
    { label: "Inactive", value: false },
];
